import { useTranslations } from '@vocab/react';
import { Heading, Stack } from 'braid-design-system';

import translations from './.vocab/index.ts';

interface Props {
  children: React.ReactNode;
}

const DocumentsSummary = ({ children }: Props) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="large">
      <Heading level="3">{t('Documents included')}</Heading>
      <Stack space="medium">
        <>{children}</>
      </Stack>
    </Stack>
  );
};

export default DocumentsSummary;
